<template>
	<span class="content">
		<ParsedMessage :network="network" :message="message" :text="errorMessage" />
	</span>
</template>

<script>
import ParsedMessage from "../ParsedMessage.vue";

export default {
	name: "MessageTypeError",
	components: {
		ParsedMessage,
	},
	props: {
		network: Object,
		message: Object,
	},
	computed: {
		errorMessage() {
			switch (this.message.error) {
				case "bad_channel_key":
					return `Impossível entrar em ${this.message.channel} - Chave de canal errada.`;
				case "banned_from_channel":
					return `Impossível entrar em ${this.message.channel} - Foste banido do canal.`;
				case "cannot_send_to_channel":
					return `Impossível escrever no canal ${this.message.channel}`;
				case "channel_is_full":
					return `Impossível entrar em ${this.message.channel} - O canal está cheio.`;
				case "chanop_privs_needed":
					return "Impossível executar acção: Não és operador do canal.";
				case "invite_only_channel":
					return `Impossível entrar em ${this.message.channel} - O canal requer convite.`;
				case "no_such_nick":
					return `O utilizador ${this.message.nick} não está na rede ou não existe.`;
				case "not_on_channel":
					return "Impossível executar acção: Não estás no canal.";
				case "password_mismatch":
					return "Password errada.";
				case "too_many_channels":
					return `Impossível entrar em ${this.message.channel} - Atingiste o máximo de canais permitidos.`;
				case "unknown_command":
					return `Comando desconhecido: ${this.message.command}`;
				case "user_not_in_channel":
					return `O utilizador ${this.message.nick} não está no canal.`;
				case "user_on_channel":
					return `O utilizador ${this.message.nick} já está no canal.`;
				default:
					if (this.message.reason) {
						return `${this.message.reason} (${this.message.error})`;
					}

					return this.message.error;
			}
		},
	},
};
</script>
